import Vue from 'vue';
import iview from 'iview';
import filter from './filter/index';
// chart组件
import LineBar from './components/chart/linebar';
import Line from './components/chart/line';
import Lines from './components/chart/lines';
import Treemap from './components/chart/treemap';
import Pie from './components/chart/pie';
import Bars from './components/chart/bars';
import Bar from './components/chart/bar/index';
import Bubble from './components/chart/bubble';
import Liquid from './components/chart/liquid';
import LiquidPart from './components/chart/liquidPart';
import XAScatter from './components/chart/xaChart/scatter';
import XANoline from './components/chart/xaChart/noLine';
import XABar from './components/chart/xaChart/bar';
import XALine from './components/chart/xaChart/line';
import ActiveBubble from './components/chart/activeBubble';
import ActiveTwoBar from './components/chart/activeChart/twoBar';
import Twoy from './components/chart/twoy';
import Scatter from './components/chart/scatter';
import Radar from './components/chart/radar';
import Funnel from './components/chart/funnel';
import Gauge from './components/chart/gauge';
import CoreBar from './components/chart/coreBar';
import CustomBar from './components/chart/customBar';
// 地图组件
import IndoorHeatMap from './components/map/indoor-heatmap/index';
import Earth from './components/map/earth/index';
import FlyLine from './components/map/flyLine';
import JingJinJiCounty from './components/map/jingjinjiCounty';
import BeiJingEffectScatter from './components/map/beijingEffectScatter';
import ChinaMapFlyPerson from './components/wuhan/china-map-fly-person';
import ChenDuPoint from './components/wuhan/chengdu-point';
import Polygon3D from './components/map/polygon-gl';
import Polygon2D from './components/map/polygon-2d';
import HeatMap from './components/map/heatmap';
import PointMap from './components/map/point';
// 文本+图文组件
import Text from './components/text/index';
import Introduce from './components/text/introduce';
import TextBar from './components/textMixing/bar';
import TextCircle from './components/textMixing/circle';
import TextPercent from './components/textMixing/percent';
import HeaderTitle from './components/text/header/index';
import OneLevelTitle from './components/text/oneLevelTitle/index';
import OneLevelTitle1 from './components/text/oneLevelTitle/index';
import TwoLevelTitle from './components/text/twoLevelTitle/index';
import TextTrend from './components/textMixing/textTrend';
import CircleTrend from './components/textMixing/circleTrend';
import SimpleRank from './components/wuhan/rank';
import Rank from './components/rank/rank';
import RankList from './components/rank/rankList';
import RelationRank from './components/rank/relationRank';
import HeaderTitle1 from './components/text/headerTitle/index';
import TabCop from './components/text/tab';
import MobileHeaderMenu from './components/text/mobileHeaderMenu/index';
import Link from './components/text/link';
import Table from './components/text/table';
// 基础组件
import Image from "./components/image/index";
import PictureText from './components/textMixing/pictureText';
import PictureTextVertical from './components/textMixing/pictureTextVertical/index';
import Timer from './components/timer/index.vue';
import TextRankNumberPerent from './components/textMixing/textRankNumberPercent/index';
import LayoutMenu from './layout/layoutMenu/layoutMenu.vue';
import LayoutMenuGroup from './layout/layoutMenuGroup/layoutMenuGroup.vue';

// 布局组件
import Background from './components/background/index';
import LayoutFree from './layout/layout-free/index';
import Border from './layout/border/default/index';
import CornerBorder from './layout/cornerBorder/index';
import BorderWrap from './components/borderwrap/BorderWrap';
import Iframe from './layout/iframe/iframe.vue';
import LayoutOverflow from './layout/layout-flex/layout-overflow';
import LayoutColumn from './layout/layout-flex/layout-column';
import LayoutRow from './layout/layout-flex/layout-row';

//武汉模板组件
import WHFlyMap from './components/wuhan/map';
import Ratio from './components/wuhan/ratio';

//预定义函数
import {transformer as jsonPathTransformer} from './data-builder/transformer/jsonpath-transformer';
import {transformer as functionTransformer} from './data-builder/transformer/function-transformer';
import {transformer as asyncLoopTransformer} from './data-builder/transformer/async-loop-transformer';

//其他组件
import ShareWechat from './components/other/share-wechat.vue';


Object.keys(filter).forEach((k) =>{
   Vue.filter(k, filter[k])
});

Vue.use(iview);

const components = {
    // 布局组件
    "de-background": Background,
    "de-layout-free": LayoutFree,
    "de-border": Border,
    "de-border-wrapper": BorderWrap,
    "de-corner-border": CornerBorder,
    'de-iframe': Iframe,
    "de-layout-column":LayoutColumn,
    "de-layout-row":LayoutRow,
    'de-layout-overflow':LayoutOverflow,
    // chart组件
    "de-pie": Pie,
    "de-line-bar": LineBar,
    "de-bubble": Bubble,
    "de-line": Line,
    "de-lines":Lines,
    "de-treemap":Treemap,
    "de-bar": Bar,
    "de-bars": Bars,
    "de-liquid": Liquid,
    "de-liquid-part": LiquidPart,
    "de-xa-scatter": XAScatter,
    "de-xa-noline": XANoline,
    "de-xa-bar": XABar,
    "de-xa-line": XALine,
    "de-active-bubble": ActiveBubble,
    "de-active-twobar": ActiveTwoBar,
    "de-twoY": Twoy,
    "de-scatter": Scatter,
    "de-radar": Radar,
    "de-funnel": Funnel,
    "de-gauge": Gauge,
    "de-core-bar": CoreBar,
    "de-customBar": CustomBar,
    // 地图组件
    'de-flyline': FlyLine,
    "de-earth":Earth,
    "de-indoor-heatmap":IndoorHeatMap,
    'de-jingjinji-county': JingJinJiCounty,
    'de-beijing-effect-scatter':BeiJingEffectScatter,
    'de-china-map-fly-person': ChinaMapFlyPerson,
    'de-chendu-heatmap':ChenDuPoint,
    'de-polygon-3d':Polygon3D,
    'de-polygon-2d':Polygon2D,
    'de-heat-map':HeatMap,
    'de-point-map':PointMap,
    // 文本+图文组件
    "de-text":Text,
    "de-introduce":Introduce,
    "de-text-bar": TextBar,
    "de-text-circle":TextCircle,
    "de-text-percent":TextPercent,
    "de-header-title": HeaderTitle,
    "de-one-level-title": OneLevelTitle,
    "de-one-level-title1": OneLevelTitle1,
    "de-two-level-title": TwoLevelTitle,
    "de-text-trend": TextTrend,
    "de-rank": Rank,
    "de-rank-list": RankList,
    "de-relation-rank": RelationRank,
    "de-simple-rank-in": SimpleRank,
    "de-rank-easy": SimpleRank,
    "de-header-title1": HeaderTitle1,
    'de-picture-text-vertical': PictureTextVertical,
    'de-text-rank-number-percent': TextRankNumberPerent,
    "de-circle-trend": CircleTrend,
    "de-tab-cop": TabCop,
    "de-mobile-header-menu": MobileHeaderMenu,
    "de-link": Link,
    "de-table": Table,
    //基础组件
    "de-image":Image,
    "de-picture-text": PictureText,
    "de-timer":Timer,
    "de-layout-menu": LayoutMenu,
    "de-layout-menu-group": LayoutMenuGroup,
    // 模板组件
    "de-wh-fly-map":WHFlyMap,
    "de-ratio": Ratio,
    //其他组件
    "de-share-wechat":ShareWechat
  };

const componentMap = {
   v1: components,
};

const getVersionComponents = (() => {
    let map = {};
    for (const v in componentMap) {
        const components = componentMap[v];
        for (const name in components) {
            map[`${name}`] = components[name];
            // map[`${name}-${v}`] = components[name];
        }
    }
    return map;
});


const install = function (Vue, opts = {}) {
    const componentsMap = getVersionComponents();
    Object.keys(componentsMap).forEach(key => {
        Vue.component(key, componentsMap[key]);
    });
};

install(Vue);


// 注册预定义函数
let functions = {jsonPathTransformer,functionTransformer,asyncLoopTransformer};
Vue.prototype.$functions = Vue.prototype.$functions||{};
for (const key in functions) {
    if (functions.hasOwnProperty(key)) {
        const func = functions[key];
        Vue.prototype.$functions[`de-${key}`] = func;
    }
}
// console.log(Vue.prototype.$functions);

export default Object.assign(components, {
    install
});
